import * as React from 'react';
import { EditOutlined } from '@ant-design/icons';
import PaymentSettingsModal from './components/Modal';
import PriceDisplay from '../../../../components/Others/PriceDisplay';

interface IPaymentSettingsProps {
  order: GQL.IOrder;
  onUpdate: (data: any) => void;
}

interface IPaymentSettingsState {
  modalOpened: boolean;
}

class PaymentSettings extends React.Component<IPaymentSettingsProps, IPaymentSettingsState> {

  constructor(props: IPaymentSettingsProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.onToggleModal = this.onToggleModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  
  public render() {
    const { order } = this.props;

    return (
      <React.Fragment>
        <div className="editBlock payment" onClick={this.onToggleModal}>
              
          <div className="icon">
            <EditOutlined onClick={this.onToggleModal} />
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Voucher</span>
            {!this.getVouchers(order.vouchers) && <b>No voucher</b>}
            {this.getVouchers(order.vouchers) && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {this.getVouchers(order.vouchers) || ({} as any)}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Method</span>
            <span>{order.paymentMethod.title}</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
            <span style={{ color: '#999897' }}>Price</span>
            <span><PriceDisplay amount={order.paymentTotal} currency={order.currency} /></span>
          </div>
          <div>
            {order.paid 
              ? <b className="orderPaid">Order paid</b> 
              : <b className="orderNotPaid">Order is not paid yet</b>}
          </div>
        </div>

        {this.state.modalOpened &&
          <PaymentSettingsModal 
            order={order}
            onSubmit={this.onSubmit}
            onClose={this.onToggleModal}
          />}
      </React.Fragment>
    );
  }

  private onToggleModal() {
    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }

  private async onSubmit(data: any) {
    await this.props.onUpdate(data);
    this.onToggleModal();
  }

  private getVouchers(vouchers: GQL.IVoucher[]) {
    if (!Array.isArray(vouchers) || vouchers.length == 0) {
      return undefined;
    }

    const tempVouchers = [] as any[];

    for (const voucher of vouchers) {
      if (voucher.title != undefined) {
        tempVouchers.push(<span key={voucher.id}>{voucher.title}</span>);
      } else {
        tempVouchers.push(<span key={voucher.id}>{voucher.voucherGroup.title}</span>);
      }
    }

    return tempVouchers;
  }
}

export default PaymentSettings;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/PaymentSettings/PaymentSettings.tsx